import { RSAA } from 'redux-api-middleware';

import { toFormData } from '../../helpers/requestHelper';
import { MusicUploadFormDataProps } from '../../components/clipGeneratorV2/music/music.types';

const BASE_ROUTE = '/after-effects/music';
const BASE_INSTITUTION_ROUTE = '/producer/institutions?all=true';

const UPLOAD_AFTER_EFFECTS_MUSIC_REQUEST = 'UPLOAD_MUSIC_REQUEST';
const UPLOAD_AFTER_EFFECTS_MUSIC_SUCCESS = 'UPLOAD_MUSIC_SUCCESS';
const UPLOAD_AFTER_EFFECTS_MUSIC_FAILURE = 'UPLOAD_MUSIC_FAILURE';

export const uploadAfterEffectsMusicFile = (body: MusicUploadFormDataProps) => ({
  [RSAA]: {
    types: [UPLOAD_AFTER_EFFECTS_MUSIC_REQUEST, UPLOAD_AFTER_EFFECTS_MUSIC_SUCCESS, UPLOAD_AFTER_EFFECTS_MUSIC_FAILURE],
    endpoint: `${BASE_ROUTE}`,
    method: 'POST',
    body: toFormData(body),
  },
});

const GET_AFTER_EFFECTS_MUSIC_REQUEST = 'GET_MUSIC_REQUEST';
const GET_AFTER_EFFECTS_MUSIC_SUCCESS = 'GET_MUSIC_SUCCESS';
const GET_AFTER_EFFECTS_MUSIC_FAILURE = 'GET_MUSIC_FAILURE';

export const getAfterEffectsMusicFiles = () => ({
  [RSAA]: {
    types: [GET_AFTER_EFFECTS_MUSIC_REQUEST, GET_AFTER_EFFECTS_MUSIC_SUCCESS, GET_AFTER_EFFECTS_MUSIC_FAILURE],
    endpoint: `${BASE_ROUTE}`,
    method: 'GET',
  },
});

const DELETE_AFTER_EFFECTS_MUSIC_REQUEST = 'DELETE_MUSIC_REQUEST';
const DELETE_AFTER_EFFECTS_MUSIC_SUCCESS = 'DELETE_MUSIC_SUCCESS';
const DELETE_AFTER_EFFECTS_MUSIC_FAILURE = 'DELETE_MUSIC_FAILURE';

export const deleteAfterEffectsMusic = (musicId: string) => ({
  [RSAA]: {
    types: [DELETE_AFTER_EFFECTS_MUSIC_REQUEST, DELETE_AFTER_EFFECTS_MUSIC_SUCCESS, DELETE_AFTER_EFFECTS_MUSIC_FAILURE],
    endpoint: `${BASE_ROUTE}/${musicId}`,
    method: 'DELETE',
  },
});

const GET_AFTER_EFFECTS_INSTITUTES_REQUEST = 'GET_INSTITUTES_REQUEST';
const GET_AFTER_EFFECTS_INSTITUTES_SUCCESS = 'GET_INSTITUTES_SUCCESS';
const GET_AFTER_EFFECTS_INSTITUTES_FAILURE = 'GET_INSTITUTES_FAILURE';

export const getAfterEffectsInstitutions = () => ({
  [RSAA]: {
    types: [
      GET_AFTER_EFFECTS_INSTITUTES_REQUEST,
      GET_AFTER_EFFECTS_INSTITUTES_SUCCESS,
      GET_AFTER_EFFECTS_INSTITUTES_FAILURE,
    ],
    endpoint: `${BASE_INSTITUTION_ROUTE}`,
    method: 'GET',
  },
});
